/* istanbul ignore file */
const styles = ({ spacing: { unit } }) => ({
  helpWrapper: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between'
  },
  lengthIndicator: {
    fontSize: 12,
    margin: [5, 0, 5, 'auto'],
    paddingLeft: unit
  }
});

export default styles;
